import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthModule } from '../auth/auth.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from '../../../common-modules/pipes/pipes.module';
import { DirectivesModule } from '../../../common-modules/directives/directives.module';
import { MomentModule } from 'ngx-moment';
import { ComponentsModule } from '../../../common-modules/components/components.module';
import { MdrDashboardsBrowserComponent } from './components/mdr-dashboards-browser/mdr-dashboards-browser.component';
import { MdrDashboardsRoutingModule } from './mdr-dashboards-routing.module';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { OrganizationsModule } from '../organizations/organizations.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTabsModule } from '@angular/material/tabs';
import { MatGridListModule } from '@angular/material/grid-list';
import { MdrDashboardsTableComponent } from './components/widgets/mdr-dashboards-table/mdr-dashboards-table.component';
import { MdrDashboardsOverviewComponent } from './components/mdr-dashboards-overview/mdr-dashboards-overview.component';
import { MdrDashboardsMdrServiceComponent } from './components/mdr-dashboards-mdr-service/mdr-dashboards-mdr-service.component';
import { MdrDashboardsAgentActionsComponent } from './components/mdr-dashboards-agent-actions/mdr-dashboards-agent-actions.component';
import { MdrDashboardsConfigurationComponent } from './components/mdr-dashboards-configuration/mdr-dashboards-configuration.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MdrDashboardsAreaChartComponent } from './components/widgets/mdr-dashboards-area-chart/mdr-dashboards-area-chart.component';
import { MdrDashboardsIndicatorComponent } from './components/widgets/mdr-dashboards-indicator/mdr-dashboards-indicator.component';
import { MdrDashboardsOrgSummaryComponent } from './components/mdr-dashboards-org-summary/mdr-dashboards-org-summary.component';
import { TimeframeModule } from '../timeframe/timeframe.module';
import { MdrDashboardsBarChartComponent } from './components/widgets/mdr-dashboards-bar-chart/mdr-dashboards-bar-chart.component';
import { MdrDashboardsPieChartComponent } from './components/widgets/mdr-dashboards-pie-chart/mdr-dashboards-pie-chart.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MdrProgressBarComponent } from './components/widgets/mdr-progress-bar/mdr-progress-bar.component';
import { MdrLoaderComponent } from './components/widgets/mdr-loader/mdr-loader.component';
import { MdrTitleComponent } from './components/widgets/mdr-title/mdr-title.component';
import { MdrDashboardsSemiCircleGaugeComponent } from './components/widgets/mdr-dashboards-semi-circle-gauge/mdr-dashboards-semi-circle-gauge.component';
import { MdrChecksIndicatorComponent } from './components/widgets/mdr-checks-indicator/mdr-checks-indicator.component';
import { MatRippleModule } from '@angular/material/core';
import { MdrDashboardsGroupComponent } from './components/widgets/mdr-dashboards-group/mdr-dashboards-group.component';
import { MdrDashboardSpikeComponent } from './components/widgets/mdr-dashboard-spike/mdr-dashboard-spike.component';
import { MdrDashboardsBannerComponent } from './components/widgets/mdr-dashboards-banner/mdr-dashboards-banner.component';

@NgModule({
    declarations: [
        MdrDashboardsBrowserComponent,
        MdrDashboardsTableComponent,
        MdrDashboardsAreaChartComponent,
        MdrDashboardsOverviewComponent,
        MdrDashboardsMdrServiceComponent,
        MdrDashboardsAgentActionsComponent,
        MdrDashboardsConfigurationComponent,
        MdrDashboardsIndicatorComponent,
        MdrDashboardsSemiCircleGaugeComponent,
        MdrDashboardsOrgSummaryComponent,
        MdrDashboardsBarChartComponent,
        MdrDashboardsPieChartComponent,
        MdrProgressBarComponent,
        MdrDashboardsPieChartComponent,
        MdrLoaderComponent,
        MdrTitleComponent,
        MdrChecksIndicatorComponent,
        MdrDashboardsGroupComponent,
        MdrDashboardSpikeComponent,
        MdrDashboardsBannerComponent,
    ],
    imports: [
        CommonModule,
        AuthModule,
        FormsModule,
        ReactiveFormsModule,
        PipesModule,
        MdrDashboardsRoutingModule,
        DirectivesModule,
        MomentModule,
        ComponentsModule,
        MatButtonModule,
        MatTableModule,
        MatInputModule,
        MatIconModule,
        MatPaginatorModule,
        MatSortModule,
        MatTabsModule,
        MatChipsModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        OrganizationsModule,
        MatCheckboxModule,
        MatMenuModule,
        MatDialogModule,
        MatDatepickerModule,
        MatGridListModule,
        NgApexchartsModule,
        TimeframeModule,
        MatTooltipModule,
        MatRippleModule,
    ],
    exports: [
        MdrDashboardsIndicatorComponent,
        MdrDashboardsBarChartComponent,
        MdrDashboardsAreaChartComponent,
        MdrDashboardsSemiCircleGaugeComponent,
        MdrDashboardsTableComponent,
        MdrDashboardsPieChartComponent,
        MdrProgressBarComponent,
        MdrLoaderComponent,
        MdrDashboardSpikeComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MdrDashboardsModule {}
